"use client";

import { useEffect } from "react";

import { trackEvent, type AnalyticsEventName } from "@/lib/analytics";

const getLinkEventName = (url: URL): AnalyticsEventName | null => {
  if (url.hostname.includes("github.com")) {
    return "github_click";
  }

  if (url.hostname === "docs.simpleble.org") {
    return "docs_click";
  }

  if (url.hostname === "simpleble.org" || url.hostname === "www.simpleble.org") {
    return "main_site_click";
  }

  if (url.origin !== window.location.origin) {
    return "outbound_click";
  }

  return null;
};

export const RouteAnalytics = (): null => {
  useEffect(() => {
    const handleClick = (event: MouseEvent): void => {
      if (!(event.target instanceof Element)) {
        return;
      }

      const link = event.target.closest<HTMLAnchorElement>("a[href]");

      if (!link) {
        return;
      }

      const href = link.getAttribute("href");

      if (!href) {
        return;
      }

      const url = new URL(href, window.location.href);
      const eventName = getLinkEventName(url);

      if (!eventName) {
        return;
      }

      const label = link.textContent?.trim().replace(/\s+/g, " ") ?? "";

      trackEvent(eventName, {
        link_text: label,
        link_url: url.href,
      });
    };

    document.addEventListener("click", handleClick);

    return () => document.removeEventListener("click", handleClick);
  }, []);

  return null;
};
